import db from './index';
import { staffRoster } from '@/data/staffRoster';
import {supabaseConfigured} from '@/services/supabaseClient';

let staffSeedPromise: Promise<void> | null = null;
export function ensureStaffUsers(): Promise<void> {
  if (staffSeedPromise) return staffSeedPromise;
  staffSeedPromise = (async () => {
    if (localStorage.getItem('zsb_staff_roster_20260828') === 'true') return;
    const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode('Mudar1234!'));
    const passwordHash = Array.from(new Uint8Array(digest), b => b.toString(16).padStart(2, '0')).join('');
    await db.transaction('rw', db.users, async () => {
      for (const account of staffRoster) {
        const existing = await db.users.where('email').equals(account.email).first();
        // Preserve existing personal passwords, active status and product assignments.
        if (existing) await db.users.update(existing.id, { ...account });
        else await db.users.add({ ...account, passwordHash, forcePasswordChange: true, active: true, createdAt: new Date().toISOString() });
      }
    });
    localStorage.setItem('zsb_staff_roster_20260828', 'true');
  })().catch(error => { staffSeedPromise = null; throw error; });
  return staffSeedPromise;
}

const DEMO_EMAIL = 'demo@zsb.com.br';
const DEMO_PASSWORD_HASH = '8d969eef6ecad3c29a3a629280e686cf0c3f5d5a86aff3ca12020c923adc6c92';

export async function ensureDemoUser(): Promise<void> {
  const existing = await db.users.where('email').equals(DEMO_EMAIL).first();
  if (existing) {
    if (existing.role !== 'Administrador') await db.users.update(existing.id, { role: 'Administrador' });
    return;
  }
  await db.users.add({
    name: 'Vendedor Demo',
    email: DEMO_EMAIL,
    passwordHash: DEMO_PASSWORD_HASH,
    phone: '(48) 99999-0000',
    role: 'Administrador',
    createdAt: new Date().toISOString(),
  });
}

const DEFAULT_USERS = [
  { name: 'Administrador ZSB', email: 'admin@zsb.com.br', phone: '(48) 99999-0001', role: 'Administrador' },
  { name: 'Gerente Personal Care', email: 'gerente@zsb.com.br', phone: '(48) 99999-0002', role: 'Gerente', division: 'Personal Care' },
  { name: 'Carla', email: 'carla@zsb.com.br', phone: '(48) 99999-0003', role: 'Vendedor', division: 'Personal Care', managerEmail: 'gerente@zsb.com.br' },
] as const;

export async function ensureDefaultUsers(): Promise<void> {
  await ensureStaffUsers();
  if (localStorage.getItem('zsb_default_users_seeded') === 'true') return;
  for (const account of DEFAULT_USERS) {
    const existing = await db.users.where('email').equals(account.email).first();
    if (!existing) {
      await db.users.add({ ...account, passwordHash: DEMO_PASSWORD_HASH, createdAt: new Date().toISOString() });
    }
  }
  localStorage.setItem('zsb_default_users_seeded', 'true');
}

let seedPromise: Promise<void> | null = null;

async function runSeed(): Promise<void> {
  try {
    // Libera o login antes de importar as tabelas grandes da planilha.
    if(!supabaseConfigured){await ensureDemoUser();await ensureDefaultUsers();}

    const configCount = await db.config.count();
    if (configCount === 0) {
      await db.config.add({ id: 1, cotacaoUsd: 5.15, cotacaoEur: 5.65, margemAlvo: 40 });
    }
  } catch (err) {
    console.error('Erro ao preparar banco:', err);
  }
}

export function seedDatabase(): Promise<void> {
  if (!seedPromise) seedPromise = runSeed();
  return seedPromise;
}
